import { render, staticRenderFns } from "./Nosotros.vue?vue&type=template&id=426415d9&scoped=true"
import script from "./Nosotros.vue?vue&type=script&setup=true&lang=js"
export * from "./Nosotros.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Nosotros.vue?vue&type=style&index=0&id=426415d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426415d9",
  null
  
)

export default component.exports